import {
  TableContext,
  type TiclickTableContextType,
} from './ticlick-table-context';

export function TiclickTableProvider<T>({
  children,
  table,
}: TiclickTableContextType<T> & { children: React.ReactNode }) {
  return (
    <TableContext.Provider
      value={{
        table,
      }}
    >
      {children}
    </TableContext.Provider>
  );
}
